(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaInstructionDetailController', RcopiaInstructionDetailController);

    RcopiaInstructionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RcopiaInstruction', 'RcopiaDose'];

    function RcopiaInstructionDetailController($scope, $rootScope, $stateParams, previousState, entity, RcopiaInstruction, RcopiaDose) {
        var vm = this;

        vm.rcopiaInstruction = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:rcopiaInstructionUpdate', function(event, result) {
            vm.rcopiaInstruction = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
